import { motion } from 'framer-motion';
import { STORY } from './data';

// ATELIER — long-form story page about Solène and the field, with timeline.
export default function Atelier() {
  return (
    <div className="bg-[#F2EBE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#6F7E62]/20">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B8654A] mb-4">— L'atelier · in the field at Les Lauves</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">A small house, <span className="italic text-[#6F7E62]">on a hill</span>.</h1>
      </section>

      {/* Editorial spread */}
      <article className="max-w-[1100px] mx-auto px-8 lg:px-14 py-20">
        <div className="aspect-[16/9] overflow-hidden mb-12">
          <img src="https://images.pexels.com/photos/4465137/pexels-photo-4465137.jpeg?auto=compress&cs=tinysrgb&w=2200" alt="" className="w-full h-full object-cover" />
        </div>
        <div className="grid md:grid-cols-[1fr_2fr] gap-12">
          <div className="md:sticky md:top-32 self-start">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A]">An essay by</p>
            <p className="font-serif text-2xl text-[#1B1A18] mt-2">Solène Bergeron</p>
            <p className="font-serif italic text-base text-[#6F7E62] mt-1">Founder · Maître formulateur</p>
            <p className="font-mono text-[10px] text-[#1B1A18]/55 mt-4">14 min read · February 2026</p>
          </div>
          <div className="font-serif text-lg lg:text-xl text-[#1B1A18]/85 leading-[1.7] space-y-6">
            <p className="first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:leading-[0.85] first-letter:text-[#B8654A] first-letter:italic">My grandmother kept a small still in the kitchen at Les Lauves where she distilled lavender for her sister's migraines. The atelier you see today is, very nearly, an enlargement of that still.</p>
            <p>We grow our own immortelle, our own lavender, and a little of the rosemary. Everything else &mdash; the shea, the rose otto, the almond &mdash; we buy from people we have known for a long time. Annick at the cooperative has supplied our shea since 1991. We will retire when she does.</p>
            <blockquote className="border-l-2 border-[#B8654A] pl-6 my-10">
              <p className="italic text-2xl lg:text-3xl leading-[1.3] text-[#1B1A18]">&ldquo;A small jar, well-poured, is worth more than a thousand jars sold quickly.&rdquo;</p>
            </blockquote>
            <p>We have refused, twice now, to be acquired. The maison is held by my daughter Léa and me. It will be held by Léa and her daughter Manon, in time. I'd rather it stayed small.</p>
          </div>
        </div>
      </article>

      {/* Timeline */}
      <section className="bg-[#E8E0D2] border-y border-[#6F7E62]/15 py-20">
        <div className="max-w-[1300px] mx-auto px-8 lg:px-14">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B8654A] mb-4">— A short chronology</p>
          <div className="grid md:grid-cols-4 gap-8 lg:gap-4 relative">
            <div className="absolute top-2 left-0 right-0 h-px bg-[#6F7E62]/30 hidden md:block" />
            {STORY.map((s, i) => (
              <motion.div key={s.yr} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="relative">
                <div className="w-3 h-3 rounded-full bg-[#B8654A] mb-5 hidden md:block" />
                <p className="font-serif text-3xl text-[#B8654A]">{s.yr}</p>
                <p className="font-serif text-base text-[#1B1A18]/85 mt-3 leading-relaxed max-w-xs">{s.t}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
